import React, { useState } from "react";
import { Grid } from "@mui/material";
import LeftBar from "./LeftBar";
import { Outlet, Route } from "react-router-dom";
import { Routes } from "react-router-dom";
import AddDeliveryAssociate from "./DeliveryAssociate/AddDA";
import AddStation from "./Station/AddStation";
import DeliveryAssociateList from "./DeliveryAssociate/DeliveryAssociateList";
import Appbar from "./Appbar";
import ViewDA from "./DeliveryAssociate/ViewDA";
import StationList from "./Station/StationList";
import Dashboard from "./Dashboard";
import ViewStation from "./Station/ViewStation";
import AddDeliveryHub from "./Station/AddDeliveryHub";
import BottomBar from "./BottomBar";
import ReceiveShipmentList from "./ReceiveShipment/ReceiveShipmentList";
import AddVendor from "./Vendor/AddVendor";
import VendorList from "./Vendor/VendorList";
import ViewVendor from "./Vendor/ViewVendor";
import DeliveryHubList from "./Station/DeliveryHubList";
import ViewDeliveryHub from "./Station/ViewDeliveryHub";
import { ToastContainer } from "react-toastify";
import AddTeam from "./AddMember/AddTeam";
import ViewTeamMember from "./AddMember/viewTeamMember";
import ViewMemberList from "./AddMember/ViewMemberList";
import { useEffect } from "react";
import { getMemberPermission } from "../services/memberAndPermissions";
import TeamList from "./AddTeam/TeamList";
import CreateTeam from "./AddTeam/CreateTeam";
import AllRunsheets from './../DeliveryOperations/AllRunsheets';
import CreateRunsheets from './../DeliveryOperations/CreateRunsheets';
import TodayRunsheets from './../DeliveryOperations/TodayRunsheet';
import DARunsheet from './../DeliveryOperations/DARunsheet';
import SearchPackets from "./SearchPackets";
import PacketInfo from './PacketInfo';
import DAReconciliation from "./Cash/DAReconcillation";
import CashDepositList from "./Cash/CashDepositList";
import ParticularDACash from "./Cash/ParticularDACash";
import AddPickupPackets from './../PickUpOperations/AddPickupPacket';
import CreateRunsheetsPickup from './../PickUpOperations/CreateRunsheetsPickup';
import TodayRunsheetsPickup from "../PickUpOperations/TodayRunsheetPickup";
import AllPacketPickupList from "../PickUpOperations/AllPickupPacketList";
import SearchPacketsForPickups from "../PickUpOperations/SearchForPickup";
import DARunsheetPickup from './../PickUpOperations/DARunsheet';
import PacketList from './ReceiveShipment/PacketList';
import AddPacketsManually from "./ReceiveShipment/AddPacketsManually";
import LeftBarVendor from "../VendorUI/LeftBarVendor";
import OrderHistory from "../VendorUI/OrderHistory";
import VendorDeliveryRequestForm from "../VendorUI/VendorDeliveryRequestForm";
import ActiveOrders from './../VendorUI/ActiveOrders';
import OrderDetails from "../VendorUI/OrderDetails";
import RequestToVendor from "../VendorUI/RequestedToVendor";
import VendorInformation from "../VendorUI/VendorInformation";

const LandingPageVendors = () => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const tokens = localStorage.getItem("token");
    const token = JSON.parse(tokens).userId;
    console.log("token: ", token);
    async function memberPermission() {
      const { data } = await getMemberPermission(token);
      if (data) {
        setPermissions(data);
      }
    }
    memberPermission();
  }, []);


  return (
    <>
      <Appbar />

      <ToastContainer />
      <Grid container spacing={2} sx={{ marginTop: "45px" }}>
        <Grid item xs={0} lg={2}  >
          <LeftBarVendor  />
        </Grid>
        <Grid item xs={12}  lg={10}>
          <Routes>
            
           
            <Route path="/orderHistory" element={<OrderHistory />}></Route>
            <Route path="/activeOrders" element={<ActiveOrders />}></Route>
            <Route path="/myInfo" element={<VendorInformation />}></Route>
            <Route path="/requestToVendor" element={<RequestToVendor />}></Route>
            <Route path="/vendorDeliveryRequest" element={<VendorDeliveryRequestForm />}></Route>
            <Route path="/vendorOrderDetails/:id" element={<OrderDetails />}></Route>
          </Routes>
        </Grid>
      </Grid>
    </>
  );
};

export default LandingPageVendors;
